import { ServicePointLastTransactions } from "./servicePointTransaction";
import { RawServicePointLastTransactions } from "./servicePointTransaction.types";

/** Matches API shape: { transactions: [...] } with transactionDate as string, earlyValue */
export const mockRawServicePointLastTransactions = (): RawServicePointLastTransactions => {
  return {
    transactions: [
      {
        total: 50015.0,
        accreditationDate: null,
        currency: "CLP",
        earlyValue: false,
        servicePointName: "CARLS SC 270",
        tellerName: "Daniel Ruiz",
        transactionDate: "2022-11-28T10:36:20",
        transactionType: "CASHIN",
      },
    ],
  };
};

export const mockServicePointLastTransactions = (
  data: RawServicePointLastTransactions = mockRawServicePointLastTransactions()
): ServicePointLastTransactions => new ServicePointLastTransactions(data);
